export default [
  {
    name: 'couples',
    labelKey: 'search.filter.couples',
    tracking: 'ga-search-form-couples',
    cy: 'rules-couples'
  },
  {
    name: 'pets',
    labelKey: 'search.filter.pets',
    tracking: 'ga-search-form-pets',
    cy: 'rules-pets'
  },
  {
    name: 'students',
    labelKey: 'search.filter.students',
    tracking: 'ga-search-form-students',
    cy: 'rules-students'
  },
  {
    name: 'smokingAllowed',
    labelKey: 'search.filter.smoking_allowed',
    tracking: 'ga-search-form-smokingAllowed',
    cy: 'rules-smoking-allowed'
  },
  {
    name: 'only_female',
    labelKey: 'search.filter.only_females',
    tracking: 'ga-search-form-only-females',
    cy: 'rules-only-female'
  },
  {
    name: 'only_male',
    labelKey: 'search.filter.only_males',
    tracking: 'ga-search-form-only-males',
    cy: 'rules-only-male'
  }
];
